<header class="sliding-sheet-header">
  <span class="d-flex align-items-center">
    <button mat-icon-button (click)="close.emit()" *ngIf="showBackButton">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3 *ngIf="!isSpecificComparable" class="py-3 px-3 d-inline-block mb-0 ms-0">
      {{
        isSubject
          ? 'Select Subject Property Manually'
          : comparableId
            ? 'Match Property Manually'
            : 'Add Comparable Manually'
      }}
    </h3>
    <h3 *ngIf="isSpecificComparable" class="py-3 px-3 d-inline-block mb-0 ms-0">Update Property Details</h3>
  </span>
</header>

<div class="scrl_sec" [formGroup]="customCompSearchForm">
  <div class="row mt-4" *ngIf="!isSpecificComparable">
    <h3 class="mb-0">Search Property</h3>
    <p class="text-secondary">Use this to auto-populate the Location Details</p>
    <div class="col-xxl-6 col-12">
      <!-- <profet-input appReadOnly formControlName="streetAddress" label="Address" /> -->
      <app-google-autocomplete (addressSelected)="fillAddressComp($event)" class="d-block" #autocomplete />
    </div>
  </div>
  <div class="mt-4 row g-3" formGroupName="addressInfo">
    <h3>Location Details</h3>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-input
        appReadOnly
        formControlName="StreetNumber"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).StreetNumber.fieldDisplayName"
        [required]="true"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-input
        appReadOnly
        formControlName="StreetName"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).StreetName.fieldDisplayName"
        [required]="true"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-input
        appReadOnly
        formControlName="UnitNumber"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).UnitNumber.fieldDisplayName"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-input
        appReadOnly
        formControlName="propertyCity"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).propertyCity.fieldDisplayName"
        [required]="true"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-select
        appReadOnly
        formControlName="propertyState"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).propertyState.fieldDisplayName"
        [options]="companyState.getEnumConfig(orderState.reportType).state || []"
        [required]="true"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <profet-input
        appReadOnly
        type="numberString"
        formControlName="propertyZip"
        [label]="companyState.getPropertyFieldConfig(orderState.reportType).propertyZip.fieldDisplayName"
        [required]="true"
      />
    </div>
    <div class="col-12 col-md-4 col-xxl-3">
      <label class="d-xxl-none">Geo Location</label>
      <div class="row">
        <div class="col-12 pe-1">
          <profet-coordinate [formControl]="coordinateCtrl" [required]="true" appReadOnly />
        </div>
      </div>
    </div>
  </div>

  @if (
    this.orderState.orderSetting?.[this.approachFactoryState.activeApproachKey]
      ?.showAdditionalAttrsOnAddCustomProperty !== false
  ) {
    <div class="mt-3 row">
      <h3>Property Details</h3>
    </div>
    <div class="row g-3" formGroupName="compAttributes">
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="PropertySubType"
          [options]="propertyTypeOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).PropertySubType.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).PropertySubType.isMultiSelect"
          [required]="orderState.activeValuationType != valuationType.SHORT_TERM_RENTAL"
        />
      </div>

      <!-- Short-Term Rental Specific Fields -->
      <div class="col-12 col-md-4 col-xxl-3" *ngIf="orderState.activeValuationType === valuationType.SHORT_TERM_RENTAL">
        <profet-input
          appReadOnly
          type="number"
          formControlName="ListPriceNightly"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ListPriceNightly.fieldDisplayName"
          [required]="true"
        />
      </div>

      <!-- Hiding Occupancy Rate as for NationWide it's the same for all comps  -->
      <!-- <div class="col-12 col-md-4 col-xxl-3" *ngIf="orderState.activeValuationType === valuationType.SHORT_TERM_RENTAL">
        <profet-input appReadOnly type="number" formControlName="OccupancyRate" label="Occupancy Rate" />
      </div> -->
      <div class="col-12 col-md-4 col-xxl-3" *ngIf="orderState.activeValuationType === valuationType.SHORT_TERM_RENTAL">
        <profet-select
          appReadOnly
          formControlName="RentalType"
          [options]="rentalTypeOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).RentalType.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).RentalType.isMultiSelect"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3" *ngIf="orderState.activeValuationType === valuationType.SHORT_TERM_RENTAL">
        <profet-input
          appReadOnly
          formControlName="RentalSource"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).RentalSource.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3" *ngIf="orderState.activeValuationType === valuationType.SHORT_TERM_RENTAL">
        <profet-input
          appReadOnly
          formControlName="RentalSourceUrl"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).RentalSourceUrl.fieldDisplayName"
        />
      </div>
      <!-- Short-Term Rental Specific Fields End -->

      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="StandardStatus"
          [options]="companyState.getEnumConfig(orderState.reportType).mlsStatus || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).StandardStatus.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).StandardStatus.isMultiSelect"
          [required]="orderState.activeValuationType != valuationType.SHORT_TERM_RENTAL && !isSubject"
        />
      </div>
      <div
        class="col-12 col-md-4 col-xxl-3"
        *ngIf="customCompSearchForm.get('compAttributes.StandardStatus')?.value?.toLowerCase() != 'sold'"
      >
        <profet-input
          appReadOnly
          formControlName="ListPrice"
          label="Listed For"
          type="number"
          [required]="orderState.activeValuationType != valuationType.SHORT_TERM_RENTAL && !isSubject"
        />
      </div>
      <div
        class="col-12 col-md-4 col-xxl-3"
        *ngIf="customCompSearchForm.get('compAttributes.StandardStatus')?.value?.toLowerCase() == 'sold'"
      >
        <profet-input
          appReadOnly
          formControlName="ClosePrice"
          label="Sold For"
          type="number"
          [required]="orderState.activeValuationType != valuationType.SHORT_TERM_RENTAL && !isSubject"
        />
      </div>

      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input appReadOnly formControlName="LotSizeSquareFeet" label="Lot Size (Sq Ft)" type="number" />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="ArchitecturalStyle"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ArchitecturalStyle.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="LivingArea"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).LivingArea.fieldDisplayName"
          type="number"
          [required]="orderState.activeValuationType != valuationType.SHORT_TERM_RENTAL && !isSubject"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="YearBuilt"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).YearBuilt.fieldDisplayName"
          type="numberString"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="RoomsTotal"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).RoomsTotal.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="BedroomsTotal"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).BedroomsTotal.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="BathroomsFullCalculated"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).BathroomsFullCalculated.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="BathroomsHalfCalculated"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).BathroomsHalfCalculated.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="BelowGradeTotalArea"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).BelowGradeTotalArea.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="BelowGradeFinishedArea"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).BelowGradeFinishedArea.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="MLSListingNumber"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).MLSListingNumber.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="MlsBoard"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).MlsBoard.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input appReadOnly formControlName="ParcelNumber" label="Parcel Number (APN)" />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input appReadOnly formControlName="TaxLegalDescription" label="Legal Description" />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="ZoningDescription"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ZoningDescription.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="ZoningCompliance"
          [options]="zoningComplianceOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ZoningCompliance.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).ZoningCompliance.isMultiSelect"
          [showEmpty]="true"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="Zoning"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).Zoning.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="Owner1FullName"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).Owner1FullName.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="Owner2FullName"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).Owner2FullName.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="AssociationYN"
          [options]="associationYNOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).AssociationYN.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).AssociationYN.isMultiSelect"
          [showEmpty]="true"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="AssociationName"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).AssociationName.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="AssociationFee"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).AssociationFee.fieldDisplayName"
          type="number"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="derivedAssociationFeeFrequency"
          [options]="derivedAssociationFeeFrequencyOptionList || []"
          [label]="
            companyState.getPropertyFieldConfig(orderState.reportType).derivedAssociationFeeFrequency.fieldDisplayName
          "
          [multiple]="
            companyState.getPropertyFieldConfig(orderState.reportType).derivedAssociationFeeFrequency.isMultiSelect
          "
          [showEmpty]="true"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          type="number"
          formControlName="Basement"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).Basement.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          type="number"
          formControlName="GarageSpaces"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).GarageSpaces.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          type="number"
          formControlName="ParkingTotal"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ParkingTotal.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="derivedLotFeatures"
          [options]="derivedLotFeaturesOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).derivedLotFeatures.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).derivedLotFeatures.isMultiSelect"
          [maxSelection]="companyState.getPropertyFieldConfig(orderState.reportType).derivedLotFeatures.maxSelection"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="LocationRating"
          [options]="locationRatingOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).LocationRating.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).LocationRating.isMultiSelect"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="derivedView"
          [options]="viewFactorsOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).ViewFactors.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).ViewFactors.isMultiSelect"
          [maxSelection]="companyState.getPropertyFieldConfig(orderState.reportType).ViewFactors.maxSelection"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-input
          appReadOnly
          formControlName="PoolFeatures"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).PoolFeatures.fieldDisplayName"
        />
      </div>
      <div class="col-12 col-md-4 col-xxl-3">
        <profet-select
          appReadOnly
          formControlName="PoolPrivateYN"
          [options]="poolYNOptionList || []"
          [label]="companyState.getPropertyFieldConfig(orderState.reportType).PoolPrivateYN.fieldDisplayName"
          [multiple]="companyState.getPropertyFieldConfig(orderState.reportType).PoolPrivateYN.isMultiSelect"
        />
      </div>
    </div>
  }
</div>

<div class="d-flex pt-3 my-5 border-top gap-2">
  <button appReadOnly mat-button color="primary" class="text-nowrap ms-auto" (click)="onResetForm()">
    <mat-icon>refresh</mat-icon> Reset Filter
  </button>
  <div class="d-flex gap-2 align-items-center">
    <button
      appReadOnly
      mat-flat-button
      color="danger"
      *ngIf="validationResult?.isDuplicate == true && validationResult?.isRemovableComparable == true"
      (click)="removingComparable()"
    >
      Remove Comparable
    </button>
    <button
      appReadOnly
      mat-flat-button
      color="accent"
      *ngIf="validationResult?.isDuplicate == true && validationResult?.isSelected == false"
      (click)="selectingComparable()"
    >
      Add to Selected Comparables
    </button>
    <button appReadOnly mat-flat-button color="accent" (click)="processComparable()" *ngIf="validationResult == null">
      {{ addButtonLabel }}
    </button>
    <label *ngIf="validationResult?.notification" class="d-flex align-items-center">
      {{ validationResult?.notification }}
    </label>
  </div>
</div>
